import* as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Stack from '@mui/material/Stack';

//Eboard class
import James_Decker from '../../media/Brothers/Headshots/Xi/James_Decker.jpg'; //Regent
import Sienna_Chien from '../../media/Brothers/Headshots/Omicron/Sienna_Chien.JPG'; //Vice Regent
import Aden_Lok from '../../media/Brothers/Headshots/Pi/Aden_Lok.JPG'; //Treasurer
import Emily_Dang from '../../media/Brothers/Headshots/Omicron/Emily_Dang.jpeg'; //Secretary
import Audrey_Xiang_Wang from '../../media/Brothers/Headshots/Pi/Audrey_Xiang_Wang.JPG'; //Scribe


const EBoard = () => {
  const eboardClass = [
    {broname: James_Decker, src: James_Decker, alt: "Regent", majorGrad: "James Decker"},
    {broname: Sienna_Chien, src: Sienna_Chien, alt: "Vice Regent", majorGrad: "Sienna Chien"},
    {broname: Aden_Lok, src: Aden_Lok, alt: "Treasurer", majorGrad: "Aden Lok"},
    {broname: Emily_Dang, src: Emily_Dang, alt: "Secretary", majorGrad: "Emily Dang"},
    {broname: Audrey_Xiang_Wang, src: Audrey_Xiang_Wang, alt: "Scribe", majorGrad: "Audrey Wang"},
  ];
  return (
    <div className = "Classes">
      {eboardClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default EBoard;